var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60pt",
    height: "100pt",
    viewBox: "0 0 60 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#fdb915ff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fdb915",
    opacity: 1,
    d: " M 47.18 2.16 C 52.14 1.05 57.77 4.82 58.16 10.00 C 58.73 13.30 56.97 16.41 54.66 18.62 C 41.92 31.19 29.24 43.82 16.55 56.44 C 12.28 60.91 3.71 59.03 1.65 53.21 C 0.11 49.74 1.33 45.54 4.07 43.03 C 16.05 31.01 28.13 19.09 40.09 7.05 C 42.15 5.06 44.28 2.81 47.18 2.16 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdb915",
    opacity: 1,
    d: " M 45.38 42.43 C 50.20 40.19 56.83 42.57 58.12 47.99 C 59.42 52.16 57.34 56.42 54.09 59.03 C 48.53 64.51 43.06 70.09 37.50 75.57 C 35.23 77.89 31.87 79.45 28.59 78.59 C 23.17 77.66 19.44 71.05 21.95 66.03 C 24.02 62.23 27.61 59.62 30.51 56.52 C 35.53 51.89 39.88 46.48 45.38 42.43 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdb915",
    opacity: 1,
    d: " M 46.35 80.48 C 53.01 77.33 61.06 84.47 58.67 91.45 C 57.12 98.24 47.35 100.43 43.03 95.05 C 38.73 90.67 40.54 82.52 46.35 80.48 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.47f7bd457db9716fec8cfe92e6b988e3.svg";
export { ForwardRef as ReactComponent };